"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useErrorStyles = require("./useErrorStyles");
var _useRegister = require("./useRegister");
var _jsxRuntime = require("react/jsx-runtime");
/** Renders a `<select>` field */
const SelectField = exports.SelectField = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    name,
    id,
    emptyAs,
    // for useErrorStyles
    errorClassName,
    errorStyle,
    className,
    style,
    // for useRegister
    validation,
    onBlur,
    onChange,
    ...rest
  } = _ref;
  const styles = (0, _useErrorStyles.useErrorStyles)({
    name,
    errorClassName,
    errorStyle,
    className,
    style
  });
  const useRegisterReturn = (0, _useRegister.useRegister)({
    name,
    validation,
    onBlur,
    onChange
  }, ref, emptyAs);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
    id: id || name,
    ...rest,
    ...styles,
    ...useRegisterReturn
  });
});